import { type FC } from "react"
import { Link, Navigate, useLocation } from "react-router"

import Layout from "~/components/layout"

const BuildYourOwnSuccessPage: FC = () => {
	const signInUrl = useLocation().state.signInUrl

	if (!signInUrl) {
		return <Navigate replace to="/build-your-own" />
	}

	return (
		<Layout>
			<div className="mx-auto flex w-full max-w-2xl flex-col gap-6 py-10">
				<div className="rounded-xl border border-slate-200 bg-white p-8 shadow-sm">
					<h1 className="text-3xl font-bold text-slate-900">Din akademi är skapad</h1>
					<p className="mt-4 leading-relaxed text-slate-600">
						Ditt Forento-konto är skapat och dina valda kurser har kopierats till din nya akademi.
					</p>
					<p className="mt-4 leading-relaxed text-slate-600">
						Logga in på Forento med samma e-postadress och lösenord som du använder här på Bokadero.
					</p>
					<a
						href={signInUrl}
						className="bg-primary hover:bg-primary/90 mt-8 inline-flex cursor-pointer rounded-lg px-8 py-3 text-lg font-semibold text-white shadow-lg transition hover:shadow-xl"
					>
						Logga in på Forento
					</a>
				</div>
				<p className="text-center">
					<Link to="/courses" className="text-primary cursor-pointer text-sm font-medium hover:underline">
						Tillbaka till mina kurser
					</Link>
				</p>
			</div>
		</Layout>
	)
}

export default BuildYourOwnSuccessPage
